import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingProvider } from "./redux/LoadingContext";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store/store";
import { PersistGate } from "redux-persist/integration/react";
import { SignalRProvider } from './services/signalR/SignalRProvider';
import { AlertProvider } from "./components/alert-context/AlertContext";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <LoadingProvider>
    {/* <React.StrictMode> */}
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SignalRProvider>
          <BrowserRouter>
            <AlertProvider>
              <App />
            </AlertProvider>
            <ToastContainer />
          </BrowserRouter>
        </SignalRProvider>
      </PersistGate>
    </Provider>
    {/* </React.StrictMode> */}
  </LoadingProvider>
);
reportWebVitals();
